import { User } from './userdto';

export class WLUser extends User {
    constructor() {
        super();
    }
}
